import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueMobileDetection from 'vue-mobile-detection';
Vue.use(VueMobileDetection)

Vue.config.productionTip = false;

import ToastService from 'primevue/toastservice';
Vue.use(ToastService);

import Tooltip from 'primevue/tooltip';
Vue.directive('tooltip', Tooltip);

// Estilos Primevue
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./assets/css/custom.css";
import "./assets/css/colors.css";
import "./assets/css/custom.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import i18n from '@/locales'
// Idle
import IdleVue from "idle-vue";

const eventsHub = new Vue();
// idleTime es el tiempo en ms que debe pasar para que se pase a estado inactivo
Vue.use(IdleVue, { eventEmitter: eventsHub, store, idleTime: 900000, startAtIdle: false });

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(VueFilterDateFormat);

window.sso = process.env.VUE_APP_SSO;
window.publicPath = window.location.origin;
window.loginCursos = process.env.VUE_APP_LOGIN_CURSOS;